1<!-- компонент: калькулятор -->
<template>
	<div v-show="dialogVisible" @click="hideDialog" class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container rack" @click.stop>

				<div class="modal-header">
					<span class="font-weight-500">
						{{ 'rack/rack' | ftc }}: &nbsp;
						<linkComponent v-if="rack && rack.rack_id && rack.rack_name"
							:url="'/rack/view/' + rack.rack_id"
							:text="rack.rack_name"
						/>
					</span>
					<button type="button" class="close" @click="hideDialog">&times;</button>
				</div>

				<div class="modal-body">
					<div v-if="unitsCount > 0" class="rack-wrapper"
						:style="`height: calc(${ unitsCount + (ZeroDevices && ZeroDevices.length ? 1 : 0) } * 24px)`">

						<div v-for="idx in unitsCount" :key="idx" class="rack-unit-no"
							:style="'left: 0; top: ' + (idx - 1) * 24 + 'px'">
							{{ unitsCount - idx + 1 }}
						</div>

						<template v-if="Devices && Devices.length">
							<a v-for="(dev, jdx) in Devices" :key="'dev-' + jdx" class="rack-unit-dev"
								target="_blank" 
								:href="'/rackdevice/view/' + dev.device_id"
								:style="deviceStyle(dev)"
								:class="{ sr: dev.device_type === 'rackdevice/server', sw: dev.device_type === 'rackdevice/switch' }"
								@mouseenter="deviceNameShow(dev, $event)"
								@mouseleave="deviceNameHide">
								<span class="online-status-before" :class="{ active: dev.device_ports_active === true }">&#9679;</span>
								<span v-if="dev.__count <= 3">&nbsp;{{ dev.device_name }}</span>
							</a>

							<span class="device-name" :style="deviceNameStyle" v-withSafeTags="deviceNameText"></span>
						</template>

						<template v-if="ZeroDevices && ZeroDevices.length">
							<div class="rack-unit-no" :style="'left: 0; top: ' + unitsCount * 24 + 'px'">0</div>
							<a v-for="(zDev, zdx) in ZeroDevices" :key="'zdev-' + zdx" class="rack-unit-dev zero"
								target="_blank" 
								:href="'/rackdevice/view/' + zDev.device_id"
								:style="deviceStyle(zDev)"
								@mouseenter="deviceNameShow(zDev, $event)"
								@mouseleave="deviceNameHide">
								<span class="online-status-before" :class="{ active: zDev.device_ports_active === true }">&#9679;</span>
								<span v-if="zDev.__count <= 3">&nbsp;{{ zDev.device_name }}</span>
							</a>
						</template>

						<div v-if="Devices && Devices.length" class="legend">
							<span class="sr">{{ 'rackdevice/server' | ftc }}</span>
							<span class="sw">{{ 'rackdevice/switch' | ftc }}</span>
							<span v-if="ZeroDevices && ZeroDevices.length" class="zero">zero unit</span>
						</div>
					</div>
					<div v-else class="rack-wrapper empty">
						<img src="../../assets/img/loading16.gif" />
					</div>
				</div>

				<div v-if="rackPlace && rackPlace.id && rackPlace.name" class="modal-footer rack">
					<span v-if="rack && rack.rack_type">{{ (filters && filters.rack_type && filters.rack_type.list && filters.rack_type.list[rack.rack_type]) || rack.rack_type | ftc }}</span>
					<linkComponent
						:url="'/datacenter/view/' + rackPlace.id"
						:text="rackPlace.name"
						:flagicon="'flag-icon-' + rackPlace.country"
					/>
					<span v-if="rack && rack.rack_units">{{ rack.rack_units }}</span>
					<span v-if="rack && rack.rack_power">{{ rack.rack_power }}</span>
					<span v-if="rack && rack.rack_price">{{ rack.rack_price }}</span>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import mixinLoader from '@/mixins/loader'
//import debounce from 'debounce'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'rackGraphic',

	//=========================================================================
	// mixins
	//=========================================================================
	mixins: [mixinLoader],

	//=========================================================================
	// свойства переданные родителем
	//=========================================================================
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		rack: {
			type: Object,
			required: false
		},
		filters: {
			type: Object
		}
	},

	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			dialogVisible: this.visible,
			Data: null,
			Devices: null,
			ZeroDevices: null,
			deviceNameStyle: { display: 'none', top: 0, left: 0 },
			deviceNameText: ''
		}
	},

	//=========================================================================
	// вычисляемые свойства компонента
	//=========================================================================
	computed: {
		unitsCount() {
			if (!this.rack || !this.rack.rack_units) return 0

			let tmp = this.rack.rack_units.split('/')
			if (!tmp || !tmp.length || tmp.length !== 2) return 0

			return parseInt(tmp[1], 10)
		},
		rackPlace() {
			if (!this.rack) return null

			return {
				id: this.rack.datacenter_id,
				name: this.rack.datacenter_name,
				country: this.rack.datacenter_country
			}
		}
	},

	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация события "onClose" - закрыть диалог
		//---------------------------------------------------------------------
		hideDialog() {
			this.$emit('onClose')
		},

		//---------------------------------------------------------------------
		// запрос списка оборудования в стойке
		//---------------------------------------------------------------------
		requestData() {
			if (!this.rack || !this.rack.rack_id) return

			this.$http.get(this.APIServerUrl + '/rack/view/' + this.rack.rack_id)
			.then(res => {
				let _dt = res && res.data && typeof res.data === 'object' ? res.data : false

				if (_dt && _dt.status === 'ok' && _dt.rack)
				{
					this.Data = _dt
					this.generateTable()
				}
			})
		},

		//---------------------------------------------------------------------
		// генерация стиля на основе данных для рисования
		//---------------------------------------------------------------------
		deviceStyle(device) {
			if (!device || !device.__top) return false
			return (
				'left: ' + device.__left +
				'; top: ' + device.__top +
				'; width: ' + device.__width +
				'; height: ' + device.__height +
				'; z-index: ' + device.__zIndex +
				';'
			)
		},

		//---------------------------------------------------------------------
		// точная координата начала отрисовки юнита по его номеру
		//---------------------------------------------------------------------
		unitY(unitNo) {
			return (this.unitsCount - unitNo) * 24
		},

		//---------------------------------------------------------------------
		// генерация поля с оборудованием
		//---------------------------------------------------------------------
		generateTable() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.Devices = null
			this.ZeroDevices = null

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!this.unitsCount) return
			if (!this.Data || !this.Data.rackdevice || !this.Data.rackdevice.length) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.Devices = []
			this.ZeroDevices = []
			let crossed = {}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.Data.rackdevice.forEach((d, z, a) => {
				// оборудование
				let device = Object.assign({}, d)
				// его координаты в юнитах
				let unitTop = d.device_unit + d.device_units - 1
				let unitBottom = d.device_unit

				// нулевые юниты пропускаем
				if (unitTop > 0 && unitBottom > 0)
				{
					// для сборки групп
					if (!(z in crossed)) crossed[z] = []
					crossed[z].push(d.device_id)

					// ищем количество в этом же юните - себя тоже посчитали
					let count = 1
					a.forEach(_d => {
						if (d.device_id !== _d.device_id)
						{
							// координаты в юнитах
							let _unitTop = _d.device_unit + _d.device_units - 1
							let _unitBottom = _d.device_unit
							// пересечение отрезков
							let isCross = false
							// 1.
							if (unitTop >= _unitTop && _unitTop >= unitBottom)
								isCross = true
							// 2.
							if (_unitTop >= unitTop && unitTop >= _unitBottom)
								isCross = true
							// 3. нулевые юниты пропускаем
							if (_unitTop <= 0 || _unitBottom <= 0)
								isCross = false
							// считаем
							if (isCross)
							{
								count++
								crossed[z].push(_d.device_id)
							}
						}
					})

					// данные для отрисовки
					device.__top = (this.unitY(unitTop) + 1) + 'px'
					device.__left = '30px'
					device.__height = (d.device_units * 24 - 2) + 'px'
					device.__width = count <= 1 ? 'calc(100% - 30px)' : 'calc(' + (100 / count) + '% - ' + (30 / count) + 'px - 2px)'
					device.__zIndex = 1
					device.__count = count

					// запоминаем
					this.Devices.push(device)
				}
				else
				{
					// запоминаем в отдельном месте
					this.ZeroDevices.push(device)
				}
			})

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проставим данные для оборудования в нулевом юните
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.ZeroDevices && this.ZeroDevices.length)
			{
				this.ZeroDevices.forEach((z, i, a) => {
					let count = a.length
					// данные для отрисовки
					z.__top = (this.unitY(0) + 1) + 'px'
					z.__left = 'calc(31px + ' + i + ' * (' + (100 / count) + '% - ' + (30 / count) + 'px))'
					z.__height = '22px'
					z.__width = count <= 1 ? 'calc(100% - 30px)' : 'calc(' + (100 / count) + '% - ' + (30 / count) + 'px - 2px)'
					z.__zIndex = 1
					z.__count = count
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// уберем группы из одного оборудования, а остальные отсортируем
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let c in crossed)
			{
				if (!crossed[c] || crossed[c].length <= 1)
					delete crossed[c]
				else
					crossed[c].sort()
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// теперь можно получить группы
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let groups = null
			if (Object.keys(crossed).length)
			{
				groups = []
				for (let c in crossed)
				{
					if (!groups.length)
						groups.push(crossed[c])
					else
					{
						let found = groups.some(arr => {
							if (JSON.stringify(arr) === JSON.stringify(crossed[c]))
							{
								return true
							}
						})
						if (!found) groups.push(crossed[c])
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если есть группы - найдем для каждого смещение
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (groups && groups.length)
			{
				// каждую группу отсортируем по высоте в юнитах
				groups.forEach((g, i) => {
					g.sort((deviceId1, deviceId2) => {
						let units1 = 0
						let units2 = 0

						this.Data.rackdevice.forEach(d => {
							if (d.device_id === deviceId1)
							{
								units1 = d.device_units
							}
							if (d.device_id === deviceId2)
							{
								units2 = d.device_units
							}
						})

						if (units1 > units2) return -1
						if (units1 < units2) return 1
						return 0
					})

					// проставим смещение для каждого оборудования в группе
					g.forEach((id, ii) => {
						this.Devices.some(dev => {
							if (dev.device_id === id)
							{
								if (ii > 0)
								{
									let count = dev.__count
									dev.__left = 'calc(31px + ' + ii + ' * (' + (100 / count) + '% - ' + (30 / count) + 'px))'
								}

								return true
							}
						})
					})
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},

		//---------------------------------------------------------------------
		// блок для наведения мышью на оборудование
		//---------------------------------------------------------------------
		// показать блок
		deviceNameShow(device, event) {
			if (!device || !event || !event.currentTarget)
			{
				this.deviceNameText = ''
				this.deviceNameStyle = { display: 'none', top: 0, left: 0 }
				return
			}

			let _coor = this.getElementOffset(event.currentTarget, true)
			let _width = event.currentTarget.offsetWidth
			this.$set(this, 'deviceNameStyle', {
				display: 'block',
				top: (_coor.top - 4) + 'px',
				left: (_coor.left + 10 + (_width && !isNaN(_width) ? _width / 2 : 30)) + 'px'
			})

			let arr = []
			this.deviceNameText = ''

			if (device.device_name) arr.push(`<b>${device.device_name}</b>`)
			if (device.device_server_type) arr.push(this.localeFtc(device.device_server_type))
			if (device.device_spec) arr.push(device.device_spec)

			if (arr.length) this.deviceNameText = arr.join('<br>')
		},

		// скрыть блок
		deviceNameHide() {
			this.deviceNameText = ''
			this.deviceNameStyle = { display: 'none', top: 0, left: 0 }
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	// наблюдаем за свойствами
	//=========================================================================
	watch: {
		visible: {
			handler: function(visible) {
				if (visible)
					this.requestData()
				else
				{
					this.Data = null
					this.Devices = null
					this.ZeroDevices = null
				}

				this.dialogVisible = visible
			},
			immediate: true
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.modal-container.rack {
	width: 95% !important;
	max-width: 700px;
}

.modal-footer.rack {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: flex-start;
	-webkit-align-items: flex-start;
}

.rack-wrapper {
	padding: 0;
	margin: 20px 0;
	position: relative;
	background-color: #f9f9f9;
}

.rack-unit-no {
	position: absolute;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: flex-end;
	-webkit-justify-content: flex-end;

	align-items: center;
	-webkit-align-items: center;

	width: 30px;
	height: 24px;
	background-color: white;
	font-size: 12px;
	text-align: right;
	padding-right: 3px;
}

.rack-unit-dev {
	position: absolute;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: center;
	-webkit-align-items: center;

	background-color: #ffeeff;
	font-size: 12px;
	padding: 0 3px;
	border: 1px solid #ccc;
	border-radius: 5px;
	transition: all 0.2s;
	cursor: pointer;
	text-align: center;
	overflow: hidden;
}
.rack-unit-dev.sr {
	background-color: #eeffee;
}
.rack-unit-dev.sw {
	background-color: #eeeeff;
}
.rack-unit-dev.zero {
	background-color: #ffeeee;
}
.rack-unit-dev > .online-status-before {
	position: relative;
	top: -1px;
}
.rack-unit-dev:hover {
	color: black;
	border-color: #666;
	background-color: white;
}

.legend {
	width: 100%;
	text-align: center;
	position: relative;
	top: -28px;
	font-size: 12px;
	font-weight: 500;
}
.legend span {
	width: 100px;
	display: inline-block;
	text-align: center;
	margin: 0 5px;
	border: 1px solid #ccc;
	border-radius: 5px;
}
.legend .sr {
	background-color: #eeffee;
}
.legend .sw {
	background-color: #eeeeff;
}
.legend .zero {
	background-color: #ffeeee;
}

span.device-name {
	position: fixed;
	padding: 5px 10px;
    border-radius: 4px;
	color: #333;
    font-size: 80%;
    font-weight: 300;
    background: #fff5ee;
    border: 1px solid #f9caa7;
    z-index: 2;
    max-width: 300px;
	word-wrap: break-word;
	pointer-events: none;
}
span.device-name:after {
	content: ''; 
    position: absolute;
    left: -10px; top: 9px;
    border: 5px solid transparent;
    border-right: 5px solid #f9caa7;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// rack.vue?b20b453c